import {EmailIntegrationStates} from "../../States";

const INITIAL_STATE = localStorage.getItem("nylasAccountInfo")
  ? JSON.parse(localStorage.getItem("nylasAccountInfo"))
  : "";

export const EmailIntegrationReducer = (state = INITIAL_STATE, action) => {
  const {type, payload} = action;

  switch (type) {
    case EmailIntegrationStates.DELETE:
      return null;
    case EmailIntegrationStates.SUCCESS:
      return {...payload, reducer_status: EmailIntegrationStates.SUCCESS};

    case EmailIntegrationStates.FAILED:
      return {...payload, reducer_status: EmailIntegrationStates.FAILED};

    case EmailIntegrationStates.RESET:
      return {...INITIAL_STATE};

    default:
      return state;
  }
};
